/**
 * Formats a raw rupee number en-IN with no decimals, with negatives in the Indian bracketed style
 * (e.g. -77710000 -> "(7,77,10,000)"). Rounds the magnitude first and signs after, so a value that rounds to zero
 * never reads "(0)". Amounts arrive raw over the wire — all unit conversion/formatting for
 * Reconciliations is client-side.
 */
export function inrAmount(value: number): string {
    const magnitude = Math.round(Math.abs(value));
    const formatted = magnitude.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    return value < 0 && magnitude !== 0 ? `(${formatted})` : formatted;
}

const INR_2DP_FORMAT = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Formats a rupee amount en-IN with exactly two decimals (200000000 -> "20,00,00,000.00"). */
export function inrAmount2dp(value: number): string {
    return INR_2DP_FORMAT.format(value);
}
